import './App.css';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

const NoPage = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: { xs: 4, md: 10 } }}>
      <Card sx={{ p: 4, maxWidth: 440, textAlign: 'center' }}>
        <Typography variant="h3" sx={{ fontWeight: 800, color: 'var(--primary)' }}>404</Typography>
        <Typography sx={{ color: 'var(--muted)', my: 2 }}>
          Well how did you get here then? Best to head back home and try again.
        </Typography>
        <Button variant="contained" href="/">Go home</Button>
      </Card>
    </Box>
  );
};

export default NoPage;
